import LinkWithLocale from 'components/LinkWithLocale'
import styled from 'styled-components'
import { theme } from 'theme'

export type StyledLinkType = 'primary' | 'secondary' | 'tertiary' | 'secondary-dark'

export const handleStyleLinkType = (type: StyledLinkType) => {
  switch (type) {
    case 'primary':
      return `color: ${theme.colors.newLightColor.white}; background-color: ${theme.colors.newLightColor.vividBlue};`
    case 'secondary':
      return `color: ${theme.colors.newLightColor.white}; background-color: ${theme.colors.newLightColor.deepBlue}; border-color: ${theme.colors.newLightColor.vividBlue};`
    case 'tertiary':
      return `color: ${theme.colors.newLightColor.white}; background-color: ${theme.colors.newLightColor.vividBlue};`
    case 'secondary-dark':
      return `color: ${theme.colors.newLightColor.vividBlue}; background-color: ${theme.colors.newLightColor.white}; border-color: ${theme.colors.newLightColor.vividBlue};`
    default:
      return theme.colors.link
  }
}

export const handleHoverStyleLinkType = (type: StyledLinkType) => {
  switch (type) {
    case 'primary':
      return `color: ${theme.colors.newLightColor.white}; background-color: ${theme.colors.newLightColor.brightnessNavy};`
    case 'secondary':
      return `color: ${theme.colors.newLightColor.white}; background-color: ${theme.colors.newLightColor.darkestBlue}; border-color: ${theme.colors.newLightColor.vividBlue};`
    case 'tertiary':
      return `color: ${theme.colors.newLightColor.white}; background-color: ${theme.colors.newLightColor.navy}; border-color: ${theme.colors.newLightColor.vividBlue}; text-transform: auto`
    case 'secondary-dark':
      return `color: ${theme.colors.newLightColor.vividBlue}; background-color: ${theme.colors.newLightColor.loginBtnCollor};`
    default:
      return theme.colors.link
  }
}

const Link = styled(LinkWithLocale)`
  display: inline-block;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semibold};
  color: ${({ theme: { colors } }) => colors.defaultButtonColor};
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  background-clip: padding-box;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  text-transform: uppercase;
  margin-inline-start: 6px;
  margin-inline-end: 6px;

  @media ${({ theme }) => theme.device.lgMax} {
    width: calc(50% - 8px);
    padding: 8px;
    font-size: 0.875rem;
    margin-top: 1rem;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }
`

export default Link
